import React, { useMemo } from "react";

export default function ApplicationItemComponent(props) {
  const {
    job_title,
    company_name,
    job_publish_schedule,
    job_nature,
    profile_status,
    profile_image,
  } = props.item;

  const statuses = useMemo(() => {
    return {
      1: "CV Shortlisted",
      2: "Reject",
      3: "On hold",
      4: "Offered",
      5: "DND",
      6: "Others",
      7: "In process",
      8: "Interview Scheduled",
      9: "Viewed(Action Pending)",
    };
  }, []);

  return (
    <div className="applications-content">
      <div className="row">
        <div className="col-md-5 d-flex">
          <div className="thums">
            {/* <img
              src={require("../../Assets/img/post.png")}
              alt=""
              className="img-fluid"
            /> */}
            {profile_image !== "" && (
              <img
                src={
                  process.env.REACT_APP_API_HOST +
                  "uploads/recruiter/" +
                  encodeURI(profile_image)
                }
                
                className="img-fluid"
                alt={job_title}
              />
            )}
          </div>
          <div>
            <h3>{job_title}</h3>
            <span>{company_name}</span>
          </div>
        </div>
        <div className="col-md-2">
          <p>
            <span className="full-time">{job_nature}</span>
          </p>
        </div>
        <div className="col-md-2">
          <p>{job_publish_schedule}</p>
        </div>
        <div className="col-md-3">
          <p>{statuses[profile_status] ?? "N/A"}</p>
        </div>
      </div>
    </div>
  );
}
